import { render, staticRenderFns } from "./PartImageUpload.vue?vue&type=template&id=4ec5aa2c"
import script from "./PartImageUpload.vue?vue&type=script&lang=js"
export * from "./PartImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec5aa2c')) {
      api.createRecord('4ec5aa2c', component.options)
    } else {
      api.reload('4ec5aa2c', component.options)
    }
    module.hot.accept("./PartImageUpload.vue?vue&type=template&id=4ec5aa2c", function () {
      api.rerender('4ec5aa2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Products/Form/Parts/PartImageUpload.vue"
export default component.exports